import HttpRequest from "./HttpRequest";
import CRUDService from "./base/CRUDService";

export default class ProfileService extends CRUDService {

  httpRequest = new HttpRequest();

  getBaseURL() {
    return 'auth/v1/profiles/';
  }

  findAll() {
    return this.httpRequest.get(this.getBaseURL());
  }

  findAllByCompanyId(companyId) {
    return this.httpRequest.get(`auth/v1/companies/${companyId}/profiles`);
  }
}



// WEBPACK FOOTER //
// ./src/services/ProfileService.js